import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryDubai = () => {
  const navigate = useNavigate();

  const DubaiData = {
    title: "Study Abroad Opportunities in Dubai (UAE)",
    mTitle: "Why Study in Dubai?",
    desc_1:
      "Dubai has rapidly emerged as a global education hub, offering world-class academic programs delivered by internationally accredited universities. Many institutions in Dubai are branch campuses of top universities from the UK, Australia, the USA, and Europe, ensuring globally recognized degrees. The education system emphasizes innovation, industry relevance, and practical learning, making Dubai an excellent destination for students pursuing business, engineering, IT, hospitality, and design programs.",
    desc_2:
      "Beyond academics, Dubai offers a truly international lifestyle with students from over 200 nationalities. Its strategic location, modern infrastructure, and strong job market provide outstanding career opportunities during and after studies. With a safe environment, cutting-edge facilities, and a thriving economy, studying in Dubai equips students with global exposure and real-world experience in one of the world’s most dynamic cities.",
  };

  const DubaiBenefits = [
    { title: "Globally Recognized Degrees", number: 100, suffix: "%" },
    { title: "International Universities", number: 60, suffix: "+" },
    { title: "Multicultural Student Community", number: 200, suffix: "+" },
    { title: "Strong Career & Internship Opportunities", number: 500, suffix: "+" },
  ];

  const DubaiUniversities = [
    { title: "Rochester Institute of Technology | DSO (RIT Dubai)", img: "/image/study-abroad/dubai/rit.webp", link: "#" },
    { title: "De Montfort University Dubai", img: "/image/study-abroad/dubai/dmu.webp", link: "#" },
    { title: "Global Business Studies - GBS Dubai", img: "/image/study-abroad/dubai/gbs.webp", link: "#" },
    { title: "Middlesex University Dubai", img: "/image/study-abroad/dubai/middlesex-university.webp", link: "#" },
   
  ];

  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-12">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {DubaiData.title}
        </h1>

        {/* Universities Carousel */}
        <div className="mb-10 mt-10">
          <h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">
            Top Universities in Dubai
          </h3>
          <p className="text-gray-600 mb-6 mt-5">
            Explore Our Partner Institutions
          </p>

          <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
          >
            {DubaiUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">
                    {univ.title}
                  </h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>
        </div>

        {/* Description */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">
          {DubaiData.mTitle}
        </h2>
        <p className="text-gray-700 mb-3 leading-relaxed">
          {DubaiData.desc_1}
        </p>
        <p className="text-gray-700 leading-relaxed">
          {DubaiData.desc_2}
        </p>

        <img
          src="/image/about/about-07/dubai.png"
          alt="Study in Dubai"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
      </section>

      {/* Benefits Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 mt-5">
          Key Benefits of Studying in Dubai
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {DubaiBenefits.map((item, idx) => (
            <div
              key={idx}
              className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100"
            >
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryDubai;
